import moment from 'moment'
import 'moment/locale/ro'

moment.locale('ro', {
  week: {
    dow: 1, // Start week on Monday
  },
})

export function getAssetUrl(assetName: string) {
  return `rezervare/static/icons/${assetName}`
}

export function wait(waitTimeInMs: number) {
  return new Promise<void>(resolve => {
    setTimeout(() => {
      resolve()
    }, waitTimeInMs)
  })
}

export function isDuringOpenHours(requestedDateTime: Date, openingHour: number, closingHour: number): boolean {
  const requestedTime = moment(requestedDateTime)
  const openTime = requestedTime.clone().set({ hour: openingHour, minute: 0, second: 0, millisecond: 0 })
  const closeTime = requestedTime.clone().set({ hour: closingHour, minute: 0, second: 0, millisecond: 0 })

  return requestedTime.isBetween(openTime, closeTime, 'minute', '[]')
}

export function getDayIndex(requestedDate: Date) {
  // moment gives 0-6, we use 1-7 (so add 1)
  return moment(requestedDate).weekday() + 1
}

export function isHourBetween(hour: number, startHour: number, endHour: number) {
  const normalizedHour = hour % 24
  const normalizedStart = startHour % 24
  const normalizedEnd = endHour % 24

  if (normalizedStart < normalizedEnd) {
    return normalizedHour >= normalizedStart && normalizedHour < normalizedEnd
  } else {
    return normalizedHour >= normalizedStart || normalizedHour < normalizedEnd
  }
}

